export default function katalTemplateString(template: string, defaultUrl: string) {
    if (template.includes('{{') && template.includes('}}')) {
        return defaultUrl;
    }
    return template;
}